export var EntityType;
(function (EntityType) {
    EntityType["Company"] = "company";
    EntityType["Coverage"] = "coverage";
    EntityType["Group"] = "group";
    EntityType["Insistence"] = "insistence";
    EntityType["Policy"] = "policy";
    EntityType["Subscription"] = "subscription";
})(EntityType || (EntityType = {}));
